export const getDateFromString = (str) => {
    let date = new Date(str);

    var months = ["January","February","March", "April", "May", "June", "July", "August", "September", "October","November", "December"];
    return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();

}

